import { create } from 'zustand';

export const useCustomLayoutsStore = create((set) => ({
  isOpen: false,
  payload: {},

  // Modal open/close
  openCustomLayoutCreate: (payload) => set({ isOpen: true, payload }),
  close: () => set({ isOpen: false, initialData:{},payload: {} }),

  // Field list state
  fields: [],

  addField: (field) =>
    set((state) => ({
      fields: [...state.fields, field],
    })),

  updateField: (index, updatedField) =>
    set((state) => {
      const fields = [...state.fields];
      fields[index] = { ...fields[index], ...updatedField };
      return { fields };
    }),

  removeField: (index) =>
    set((state) => {
      const fields = [...state.fields];
      fields.splice(index, 1);
      return { fields };
    }),

  reorderFields: (newOrder) => set({ fields: newOrder }),

  resetFields: () => set({ fields: [] }),
}));

export const openCustomLayoutCreate = (payload) => {
  const store = useCustomLayoutsStore.getState();
  store.openCustomLayoutCreate(payload);
};

export const closeCustomLayoutCreate = () => {
  const store = useCustomLayoutsStore.getState();
  store.close();
};
